module.exports = __webpack_public_path__ + "static/a5561ecc4590265f95b3001a5acfa39c241eea979b7325f3abb1aa6aea89c420-141805865579f149a30978bcbb738b0d.png";